import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  SettingCreateSetting,
  SettingFilterSetting,
  SettingUpdateSetting,
} from "../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

function SettingAE() {
  const [isLoading, setLoading] = useState(true);
  const [form, setForm] = useState({});

  const navigate = useNavigate();

  let { id } = useParams();
  const start = async () => {
    try {
      if (id) {
        const SettingFilterSettingData = await SettingFilterSetting(
          {
            id: id,
          }
        );
        if (
          SettingFilterSettingData.status &&
          SettingFilterSettingData.status === 200
        ) {
          setForm(SettingFilterSettingData.data.data.data[0]);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    let validation = true;
    if (form.key === "") {
      toast.error("Key را وارد نمایید ");
      validation = false;
    }
    if (form.value === "") {
      toast.error("Value را وارد نمایید ");
      validation = false;
    }
    if (form.description === "") {
      toast.error("Description را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setLoading(true);
      try {
        if (id) {
          const SettingUpdateSettingData =
            await SettingUpdateSetting(form);
          if (
            SettingUpdateSettingData.status &&
            SettingUpdateSettingData.status === 200
          ) {
            toast.success("بروزرسانی با موفقیت انجام شد");
            navigate("/Panel/Settings");
          }
        } else {
          const SettingCreateSettingData =
            await SettingCreateSetting(form);
          if (
            SettingCreateSettingData.status &&
            SettingCreateSettingData.status === 200
          ) {
            toast.success("افزودن  با موفقیت انجام شد");
            navigate("/Panel/Settings");
          }
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newForm = { ...form };
    newForm[e.target.id] = e.target.value;
    setForm(newForm);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-wrap  ">
              <InputCus
                type="text"
                name="key"
                id="key"
                text="Key"
                className="m-2"
                value={form.key || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="value"
                id="value"
                className="m-2"
                text="Value"
                value={form.value || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                type="text"
                name="description"
                id="description"
                className="m-2"
                text="Description"
                value={form.description || ""}
                onChange={handleChangeSearch}
              />
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button onClick={AddUpdate} className="butAU">
                {id ? "ویرایش" : "افزودن"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SettingAE;
